(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-content"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.FAQs').forEach(function (faqSection) {
    var titles = faqSection.querySelectorAll('.accrodion-title');

    titles.forEach(function (title) {
      title.addEventListener('click', function () {
        toggle(title);
      });
      title.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle(title);
        }
      });
    });

    function toggle(title) {
      var content = title.nextElementSibling;
      var isOpen = title.classList.contains('active');

      titles.forEach(function (t) {
        t.classList.remove('active');
        t.setAttribute('aria-expanded', 'false');
        if (t.nextElementSibling) {
          t.nextElementSibling.classList.remove('is-selected');
        }
      });

      if (!isOpen) {
        title.classList.add('active');
        title.setAttribute('aria-expanded', 'true');
        content.classList.add('is-selected');
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-logo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.featured_logo .logos_slider');

  sliders.forEach(function (slider) {
    // skip drag setup entirely if there's nothing to scroll
    if (slider.scrollWidth <= slider.clientWidth) return;

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var rafId = null;
    var pendingX = null;

    function onMove(e) {
      pendingX = e.pageX;
      if (rafId) return;
      rafId = requestAnimationFrame(function () {
        rafId = null;
        if (!isDown || pendingX === null) return;
        var x = pendingX - slider.offsetLeft;
        var walk = (x - startX) * 1.5;
        slider.scrollLeft = scrollLeft - walk;
      });
    }

    slider.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    }, { passive: true });

    ['mouseleave', 'mouseup'].forEach(function (evt) {
      slider.addEventListener(evt, function () {
        isDown = false;
      }, { passive: true });
    });

    slider.addEventListener('mousemove', onMove, { passive: true });
  });
});

  } catch(e) { console.error(e); }
})();
})();
